module.exports = __webpack_public_path__ + "img/bg-mobile.eb0ab972.png";